import { render } from "./Ourdoctor.vue?vue&type=template&id=67a5c6bf"
import script from "./Ourdoctor.vue?vue&type=script&lang=js"
export * from "./Ourdoctor.vue?vue&type=script&lang=js"

import "./Ourdoctor.vue?vue&type=style&index=0&id=67a5c6bf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__